<template lang="pug">
  #ProfilePhotoStickerComponent.profile_photoSticker.rounded-circle.m-auto.bg-white.position-relative
    .d-flex.justify-content-center.position-relative.w-100.h-100
      b-img.w-100.h-100.rounded-circle(
        :src="profileUrl ? profileUrl : 'xxx'",
        fluid,
        alt="Photo Sticker",
        :onerror="defaultPhotoSticker",
        style="object-fit: contain;",
        @click="imgHandler()"
      )
      //- 更換頭貼
      b-button.profile_pic_icon(
        v-if="changeProfile",
        @click="changeProfileImgHandler()",
        style="border: 0.2rem solid #000!important;"
      )
        i.custom.icon-photo
    //- 叉叉
    b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-2.cancelProfileBtn(
      v-if="cancelProfile",
      variant="primary"
      @click="cancelProfileImgHandler()"
    )
      i.custom.icon-icon_close
</template>

<script>
import defaultPhotoStickerUrl from '@/assets/images/default/defaultProfileImg.png';

export default {
  name: 'ProfilePhotoStickerComponent',
  props: {
    // 可有可無, 幫助判斷用
    id: {
      type: [String, Number]
    },
    profileUrl: {
      type: String,
      default: 'xxx'
    },
    // 更換大頭貼
    changeProfile: {
      type: Boolean,
      default: false
    },
    // 刪除選擇的大頭貼
    cancelProfile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defaultPhotoSticker: `this.src="${defaultPhotoStickerUrl}"`
    };
  },
  methods: {
    imgHandler() {
      this.$emit('imgHandler', this.id);
    },
    changeProfileImgHandler() {
      this.$emit('changeProfileImgHandler');
    },
    cancelProfileImgHandler() {
      this.$emit('cancelProfileImgHandler', this.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.changeProfileBtn {
  position: absolute;
  bottom: 0;
  width: 30px;
  height: 30px;
}

.cancelProfileBtn {
  position: absolute;
  right: -15px;
  top: -5px;
  width: 30px;
  height: 30px;
}

.profile_pic_icon {
  font-size: 1rem;
  color: #000;
  background-color: #d9d9d9;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  position: absolute;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  bottom: -0.5rem;
  right: 0.2rem;
}

@font-face {
  font-family: "icon";
  src: url("../../assets/fonts/icon.eot?hrpp7d");
  src: url("../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

i {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-photo:before {
  content: "\e902";
}

.icon-icon_close:before {
  content: "\e908";
}
</style>
